var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookStudyTutorials(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 272 448.99",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white",
    stroke: "white"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    d: "M548.65,250c.77-24.8,3.21-46.14,9.35-47,3.59-.52,7.58,6.1,10.55,12.22l78.12,44.11-11.34,12L634.67,426l22-22.67,25.33,50V294.67l10-8,42,22.66a22,22,0,0,1,9,7.67c5.13,7.71,3.37,16.05,3,17.67l1,267a19.64,19.64,0,0,1-9,8.38,20.26,20.26,0,0,1-16,0L542,508c0-.08,4.82-157,4.82-157C547.06,309.21,547.88,274.92,548.65,250Z",
    transform: "translate(-542 -162.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M621,486",
    transform: "translate(-542 -162.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017,201",
    transform: "translate(-542 -162.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831,566",
    transform: "translate(-542 -162.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869,485",
    transform: "translate(-542 -162.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958,458",
    transform: "translate(-542 -162.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997,388",
    transform: "translate(-542 -162.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005,210",
    transform: "translate(-542 -162.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939,332",
    transform: "translate(-542 -162.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135,166",
    transform: "translate(-542 -162.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "none",
    strokeWidth: "20px",
    d: "M560.6,214.67c11.33-14.37,34.42-39,66.77-41.8,21.66-1.89,43.48,10.47,87.1,35.19,15.19,8.6,23.58,14.5,85,51l2,1.22",
    transform: "translate(-542 -162.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120,76",
    transform: "translate(-542 -162.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 308,
    rx: 11.5,
    ry: 11.5,
    width: 23,
    x: 249,
    y: 88.32
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookStudyTutorials);
export default __webpack_public_path__ + "static/media/bookStudyTutorials.002d043602c6d2742e4bed37a3543e07.svg";
export { ForwardRef as ReactComponent };